export default "__VITE_ASSET__BpI9zPwz__"